import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: []
}

// getters
const getters = {
  allPenawaranJalur: state => state.all,
  getKodePenawaranByKeys: state => (kodeJalur, tahun, gelombang) => {
    let query = ''
    query = state.all.filter(penawaran => penawaran.kode_jalur === kodeJalur && penawaran.tahun === tahun && penawaran.gelombang === gelombang)
    return query[0].kode_penawaran
  },
  getPenawaranByKeys: state => (kodeJalur, tahun, gelombang) => {
    let query = ''
    query = state.all.filter(penawaran => penawaran.kode_jalur === kodeJalur && penawaran.tahun === tahun && penawaran.gelombang === gelombang)
    return query[0]
  },
  getPenawaranByKode: state => (kodePenawaran) => {
    let query = ''
    query = state.all.filter(penawaran => penawaran.kode_penawaran === kodePenawaran)
    return query[0]
  }
}

// actions
const actions = {
  getAllPenawaranJalur ({ commit }) {
    api.get('/v1/public/penawaran_jalur')
      .then(response => {
        let responseData = response.data
        commit(types.PENAWARAN_JALUR_RECEIVE, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.PENAWARAN_JALUR_RECEIVE] (state, { responseData }) {
    state.all = responseData.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/penawaran-jalur.js